import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Paths } from './routePaths';
import { USER_ROLES } from '../utils/constants';
import { useImpersonation } from '../hooks/useImpersonation';
import { consumeSuperadminReturnRedirect } from '../Services/impersonationSession';
import { isLearnerSessionRoute } from '../utils/learnerSessionRoutes';

const SuperadminLearnerRouteGuard = () => {
  const history = useHistory();
  const location = useLocation();
  const impersonation = useImpersonation();
  const wasImpersonating = useRef(impersonation.active);

  useEffect(() => {
    const returnedToSuperadmin = wasImpersonating.current && !impersonation.active;
    wasImpersonating.current = impersonation.active;

    if (impersonation.active) {
      return;
    }

    if (returnedToSuperadmin) {
      if (!consumeSuperadminReturnRedirect() && location.pathname !== Paths.Dashboard) {
        history.replace(Paths.Dashboard);
      }
      return;
    }

    const role = (localStorage.getItem('role') || '').trim();
    if (role !== USER_ROLES.SUPER_ADMIN) {
      return;
    }
    if (!isLearnerSessionRoute(location.pathname)) {
      return;
    }
    history.replace(Paths.Dashboard);
  }, [history, impersonation.active, location.pathname]);

  return null;
};

export default SuperadminLearnerRouteGuard;
